<template>
    <div>   
        <h3>{{assignment.title}}
        <v-btn-toggle v-model="assignmentIndex" mandatory>
            <v-btn x-small dense>Assignment</v-btn>
            <v-btn x-small dense>Discussion</v-btn>
            <v-btn x-small dense>My solutions</v-btn>
            <v-btn x-small dense>My ratings</v-btn>
            <v-btn x-small dense>My bug-reports</v-btn>
        </v-btn-toggle></h3>
        <div v-html="assignment.assignment" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            assignmentIndex : 0
        }
    },    
    props :
        ['assignment'],
}
</script>
